export default {
  toBeDefined: ({ toBeDefined }) => toBeDefined,
};
